import { Component, Inject, PLATFORM_ID, signal, input, computed, effect } from "@angular/core";
import * as Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { CertChartOptions } from "./cert-chart-options";
import { Options } from "highcharts";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { HighchartsChartModule } from "highcharts-angular";
import { extendHighcharts } from "../../../helpers/highcharts";
import { CertBubbleLegendGroup, CertBubbleSeries } from "./types";
HC_more(Highcharts);

@Component({
  selector: "cert-chart-generic",
  templateUrl: "cert-chart.html",
  styleUrls: ["cert-chart.scss"],
  imports: [HighchartsChartModule, CommonModule, TranslateModule],
})
export class CertChartGeneric {
  protected series = input.required<CertBubbleSeries[]>();
  protected legendGroups = input.required<CertBubbleLegendGroup[]>();
  protected legendTitle = input.required<string>();
  protected chartTitle = input.required<string>();
  protected loading = input(false);

  private chartRef = signal<Highcharts.Chart>(null);
  protected highcharts: typeof Highcharts = Highcharts;
  protected chartOptions: Options = CertChartOptions;

  public isBrowser = signal(false);

  protected noDataFound = computed(() => !this.loading() && this.haveChart() && this.series().length === 0);
  protected haveChart = computed(() => this.chartRef() && "angular" in this.chartRef());

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    if (isPlatformBrowser(platformId)) {
      extendHighcharts(this.highcharts);
      this.isBrowser.set(true);
    }

    effect(() => {
      if (
        this.haveChart()
        && this.chartRef().options !== undefined
        && this.legendGroups().length > 0
        && this.series().length > 0
      ) {
        this.setSeries();
      }
    });

    effect(() => {
      if (this.haveChart() && this.chartRef().options !== undefined) {
        this.loading() ? this.chartRef().showLoading(" ") : this.chartRef().hideLoading();
      }
    });
  }

  setChartInstance(chart: Highcharts.Chart) {
    this.chartRef.set(chart);
  }

  clearSeries() {
    if (!this.haveChart() || this.noDataFound() || !this.chartRef().series) {
      return;
    }

    while (this.chartRef().series.length > 0) {
      this.chartRef().series[0].remove(false);
    }
    this.chartRef().redraw(); // update the visual aspect
  }

  setSeries() {
    if (this.series().length === 0) {
      return;
    }
    this.clearSeries();

    this.series().forEach((serie) => {
      this.chartRef().addSeries(
        {
          name: serie.name,
          type: "packedbubble",
          data: [serie],
        },
        false,
      );
    });

    this.chartRef().redraw(true);
  }
}
